// extracted by mini-css-extract-plugin
module.exports = {"CutomTitleWrap":"styles_CutomTitleWrap__1oZ47","resumeText":"styles_resumeText__1sIi4","scoreText":"styles_scoreText__331O8"};